<template>
   <div class="container-fluid" style="user-select: none; background: linear-gradient(to top, #471416, #471416); height: 100vh">
        <div class="row mb-5 pb-5 pt-5">
            <div class="col-md-6 col-sm-12">
                <div class="logo mt-5 d-flex">
                    <img class="logo-img" src="/build/assets/img/brand/logo.png" style="border-radius: 5px; width: 200px; height: 200px; margin-top: 4rem; margin-left: 4rem; ">
                </div>
                <div class="left pt-5" style="margin: 0 0 0 5rem;">
                    <div class="p1">
                        <h1 class="heading-text" style="font-weight: bolder; color: #f5dd02">
                            The Best Betting Application in Myanmar
                        </h1>
                    </div>
                    <div class="p2">
                        <p class="text-white para-text mt-4">
                            You can play football Maung Body, Thai 2D 3D and Shan Ko Mee on your android phone!
                        </p>
                    </div>
                    <div class="button pt-2">
                        <a href="https://yoeyar.vip/yoeyar_version_1.0.3.apk" download>
                            <button class="btn btn-success" >
                                Download Android App
                            </button>
                        </a>
                        <button class="btn btn-info ml-2"  @click="toGoHome()">
                            Play Online
                        </button>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-6 col-sm-12 d-flex right-img-container" style="padding-top: 10rem">
                <img src="/build/assets/img/theme/first.png" class="mt-5 rounded mx-auto my-auto img-fluid text-img">
                <img src="/build/assets/img/theme/second.png" class="mt-5 rounded mx-auto my-auto img-fluid phone-img">
                <img src="/build/assets/img/theme/third.png" class="mt-5 rounded mx-auto my-auto img-fluid text-img">
            </div> -->
        </div>
        <div class="row d-flex main-footer" style="margin-top: 16rem;">
            <p class="mx-auto text-sm" style="text-align: center; font-weight: bold; color: #ddc35a">
                @ V1 ရှမ်းကိုးမီး 2023 Renamed <br>
                Privacy Teams FAQ
            </p>
        </div>
   </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    toGoHome(){
        localStorage.removeItem('token');
        this.$router.push('/home')
    }
  },
  mounted() {
  },
};
</script>
<style scoped>
    .text-img {
        width: 150px;
        height: 150px;
    }
    .phone-img {
        width: 140px;
        height: 270px;
    }
    h5{
        color: #fff;
    }
    .p1{
        font-size: 50px;
        color: #fff;
    }
    .img-cont {
        width: 30rem;
    }
    .heading-text {
        font-size: 32px !important;
    }
    .para-text {
        font-size: 18px !important;
    }

@media (max-width: 786px) {
        .text-img {
            width: 130px !important;
            height: 90px !important;
        }
        .phone-img {
            width: 100px !important;
            height: 180px !important;
        }
        .img-cont {
            width: 15rem;
        }
        .main-footer {
            margin-top: 0rem !important;
            padding-top: 3.5rem !important;
            /* padding-bottom: 1rem !important; */
        }
        .right-img-container {
            padding-top: 4rem !important;
        }
        .left {
                margin-left: 0.4rem !important;
        }
        .para-text {
            font-size: 16px !important;
            font-weight: normal !important;
        }
        .btn-md {
            padding: 4px 20px;
            font-size: 14px;
            margin-top: 1rem;
            margin-left: 0.3rem;
            margin-right: 0.3rem;
        }
        .logo-img{
            margin: auto !important;
            width: 120px !important;
            height: 120px !important;
        }
        .logo{
            margin-top: 1rem !important;
        }
        .heading-text{
            font-size: 25px !important;
        }
}
</style>
